// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__OEZIl","consentsList":"PatientConsents_consentsList__2zK1I","consentsListEmpty":"PatientConsents_consentsListEmpty__15YBU"};